import Http from '../Http';

const baseUrl = `${process.env.VAPI_BASE_URL}/dmas`;

export default {
  list: (data, options) => Http.post(`${baseUrl}/search`, data, options),
  getById: (id, options) => Http.get(`${baseUrl}/${id}`, options),
  getZipcodes: (id, options) => Http.get(`${baseUrl}/${id}/zipcodes`, options),
};
